import { render, staticRenderFns } from "./GlobalJsGroovyEditor.vue?vue&type=template&id=0f2e6d47&scoped=true"
import script from "./GlobalJsGroovyEditor.vue?vue&type=script&lang=js"
export * from "./GlobalJsGroovyEditor.vue?vue&type=script&lang=js"
import style0 from "./GlobalJsGroovyEditor.vue?vue&type=style&index=0&id=0f2e6d47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2e6d47",
  null
  
)

export default component.exports